/**
 * Akamai Header utility
 *
 * Will return specified Akamai header values.
 * regEx Pattern example  = /\b(zip=)([0-9]{5})/ig;
 */

import getAkamaiHeader from './getAkamaiHeader';
export default function getAkamaiHeaderValue(headers, regExPattern) {
  if (headers === void 0) {
    headers = {};
  }
  const akamaiHeader = getAkamaiHeader(headers);
  if (akamaiHeader) {
    const matchArray = akamaiHeader.match(regExPattern);
    if (Array.isArray(matchArray) && matchArray.length > 0) {
      return matchArray[0].split('=')[1];
    }
  }
  return '';
}